import React from 'react';

const MultilineText = React.memo(
  ({ dangerouslySetInnerHTML, children, className }) => {
    if (!dangerouslySetInnerHTML) {
      return (
        <div style={{ whiteSpace: 'pre-line', wordBreak: 'break-word' }} className={className}>
          {children}
        </div>
      );
    }

    return (
      <div
        style={{ whiteSpace: 'pre-line', wordBreak: 'break-word' }}
        className={className}
        dangerouslySetInnerHTML={dangerouslySetInnerHTML}
      />
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.children === nextProps.children &&
      prevProps.className === nextProps.className &&
      prevProps.dangerouslySetInnerHTML?.__html === nextProps.dangerouslySetInnerHTML?.__html
    );
  },
);

export default MultilineText;
